import { Link } from "react-router-dom";

interface TitleBarProps{
    title:string;
    subTitle?:string;
}
const TitleBar : React.FC<TitleBarProps> = ({title,subTitle}) => {
    return (

        <>
            <div style={{
                 paddingLeft: "clamp(.2rem, 10vw, 15rem)",
                 paddingRight: "clamp(.2rem, 10vw, 15rem)",
                 paddingTop: "clamp(.2rem, 2vw, 4rem)",
                 paddingBottom: "clamp(.2rem, 2vw, 4rem)",
                 
            }}className=" text-black">
                <div className="pt-10 pb-0 group font-bold">
                    <p className="text-custom-darkblue main-heading text-opacity-80 ">{title}</p>
                    <div className="title-divider"></div>
                </div>
            </div>
        </>

    )
}
export default TitleBar